import React from "react"

import { FormattedMessage } from "react-intl"

import { isFeatureEnabled } from "config/feature-flags"
import { ModuleContainer } from "components/ModuleContainer"
import {
	unCollapseSideBar,
	useApplicationContext,
} from "context/applicationContext"

import { submodules } from "./submodules"
import { RETENTION } from "./Habits/constants"
import PromotionBanner from "../Shared/PromotionBanner"
import { CROSS_SELLING_SUBMODULE } from "../../constants/features"

import "./index.scss"

const CustomerBehavior: React.FC = () => {
	const { setCustomerHabitsDefaultMetric } = useApplicationContext()
	unCollapseSideBar()
	setCustomerHabitsDefaultMetric(RETENTION)

	return (
		<ModuleContainer
			submodules={submodules}
			className="module-container"
			bannerContent={
				isFeatureEnabled("promotionBanner") && (
					<PromotionBanner bannerId={CROSS_SELLING_SUBMODULE} />
				)
			}
			titleContent={
				<FormattedMessage id={"phronesis.menu.option.customerbehavior.title"} />
			}
		/>
	)
}

export default CustomerBehavior
